import { useMemo } from "react";
import { Hooks } from "@xt/xtbase";
const { useTranslation } = Hooks;

export default (financialProductObj) => {
  const t = useTranslation();

  const productName = useMemo(() => {
    const obj = {
      SAVING: t("finance.savings"),
      STAKING: t("finance.staking"),
      HASH_RATE: t("finance.hashrate"),
    };
    return obj[financialProductObj.category];
  }, [financialProductObj]);

  return productName;
};
